import backendApi from "./backendApi";

export const downloadInvoice = async (rideId) => {
    try {
        const response = await backendApi.get(`/api/download-invoice/${rideId}`, {
            responseType: 'blob'
        });

        if (response.status !== 200) {
            throw new Error(`Failed to download invoice: ${response.statusText}`);
        }

        const blob = response.data;
        const url = window.URL.createObjectURL(blob);

        const a = document.createElement('a');
        a.href = url;

        const today = new Date();
        const formattedDate = today.toISOString().split('T')[0];

        a.download = `saskaita-${formattedDate}.pdf`;

        document.body.appendChild(a);
        a.click();
        a.remove();
        window.URL.revokeObjectURL(url);
    } catch (err) {
        console.error('Invoice download error:', err);
        alert('Nepavyko atsisiųsti sąskaitos.');
    }
};